import Swiper from 'swiper';
import { Pagination, Autoplay, Manipulation } from 'swiper/modules';

function dm_a02() {

    if ($('.a-02').length) {
        const swiper = new Swiper(".a-02", {
            modules: [Autoplay, Pagination, Manipulation],
            speed: 1250,
            loop: false,
            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween: 27,
            centeredSlides: true,
            pagination: {
                el: '.a-02-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '"></span>';
                },
            },
            breakpoints: {
                0: { slidesPerView: 1, centeredSlides: false },
                576: { slidesPerView: 2, centeredSlides: false },
                768: { slidesPerView: 3, centeredSlides: false },
                992: { slidesPerView: 5, centeredSlides: false },
            }
        });
    }
}

export { dm_a02 };
